// RegistrationContentMobile.js
import React, { useState } from "react";
import { Container, Tabs, Tab } from "@mui/material";
import TopTitleBannerMobile from "../component/TopTitleBannerMobile";
import ClientsGroupAttendanceRegisterMobile from "../component/registrationcomponent/ClientsGroupAttendanceRegisterMobile";

import ClientRegisterMobile from "../component/registrationcomponent/ClientRegisterMobile";

export default function RegistrationContentMobile() {
  const [activeTab, setActiveTab] = useState(0);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  return (
    <div className="right-container-mobile">
      <TopTitleBannerMobile title={"Registration"} />
      <Container style={{ marginTop: "20px" }}>
        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          indicatorColor="primary"
          textColor="primary"
          variant="fullWidth"
        >
          <Tab label="Group Attendance" />
          <Tab label="Clients Register" />
        </Tabs>
        <div style={{ marginTop: "20px" }}>
          {activeTab === 0 && <ClientsGroupAttendanceRegisterMobile />}
          {activeTab === 1 && <ClientRegisterMobile />}
        </div>
      </Container>
    </div>
  );
}
